<template>
  <div v-cloak>
    <div class="vx-card mb-4">
      <div class="vx-card__collapsible-content vs-con-loading__container">
        <div class="vx-card__body card-body">
          <div class="flex pb-2">
            <div class="w-full">
              <vs-button
                @click="showFilters = !showFilters"
                class="bg_purple float-right"
              >
                <div class="px-3">
                  <feather-icon
                    icon="FilterIcon"
                    svgClasses="h-4 w-4"
                    class="ico"
                  />
                  {{ $t("Filter") }}
                </div>
              </vs-button>
            </div>
          </div>
          <div class="vx-row" v-if="showFilters">
            <div class="vx-col w-full">
              <form>
                <div class="vx-row mb-6">
                  <div class="vx-col lg:w-1/4 w-full mt-1">
                    <label class="vs-input--label">{{
                      $t("BankPaymentState")
                    }}</label>
                    <div class="w-full">
                      <v-select
                        label="title"
                        :options="bankPaymentStates"
                        v-model="gridSearchData.State"
                        :reduce="(x) => x.id"
                        dir="rtl"
                      >
                      </v-select>
                    </div>
                  </div>
                  <div class="vx-col lg:w-1/4 w-full mt-1">
                    <label class="vs-input--label">{{
                      $t("SaleInterface")
                    }}</label>
                    <div class="w-full">
                      <v-select
                        label="title"
                        :options="saleInterfaces"
                        v-model="gridSearchData.SaleInterface"
                        :reduce="(x) => x.id"
                        dir="rtl"
                      >
                      </v-select>
                    </div>
                  </div>
                  <div class="vx-col lg:w-1/4 w-full mt-1">
                    <label class="vs-input--label">{{ $t("BankType") }}</label>
                    <div class="w-full">
                      <v-select
                        label="title"
                        :options="bankTypes"
                        v-model="gridSearchData.BankType"
                        :reduce="(x) => x.id"
                        dir="rtl"
                      >
                      </v-select>
                    </div>
                  </div>
                  <div class="vx-col lg:w-1/4 w-full mt-1">
                    <div class="w-full">
                      <vs-input
                        :label="$t('PaymentId')"
                        v-model="gridSearchData.BankPaymentIdInWebsite"
                        dir="ltr"
                        @keyup.enter="submitFilter"
                        v-trim-space
                      />
                    </div>
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col w-full">
                    <vs-button
                      type="filled"
                      class="float-right"
                      @click.prevent="submitFilter()"
                      >{{ $t("SubmitFilter") }}</vs-button
                    >
                    <vs-button
                      type="filled"
                      class="float-right ml-4"
                      id="reset-btn"
                      @click.prevent="resetForm"
                      >{{ $t("ResetFilter") }}</vs-button
                    >
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="vx-row pt-4">
            <div class="vx-col w-full mb-base">
              <data-grid
                ref="grid"
                stripe
                :data-source="gridDataSource"
                :search-data="gridSearchData"
                :columns="[
                  { title: $t('OrderNumber'), sort: 'OrderNumber' },
                  { title: $t('PaymentId'), sort: 'PaymentId' },
                  { title: $t('PaymentAmount'), sort: 'PaymentAmount' },
                  { title: $t('ReferenceId'), sort: 'ReferenceId' },
                  { title: $t('Bank'), sort: 'Bank' },
                  { title: $t('Description'), sort: 'Description' },
                  { title: $t('CreateOn'), sort: 'CreateOn' },
                ]"
              >
                <template slot-scope="{ row }">
                  <td style="width: 10%">
                    {{ row.basketInfo.basketId }}
                  </td>
                  <td style="width: 10%">
                    {{ row.bankPaymentIdInWebsite }}
                  </td>
                  <td style="width: 15%">
                    {{ Number(row.amount).toLocaleString() }}{{ $t("Rials") }}
                  </td>
                  <td style="width: 15%">
                    <span v-if="row.referenceId == null">-</span>
                    {{ row.referenceId }}
                  </td>
                  <td style="width: 10%">
                    <span v-if="row.bankType">
                      <span v-if="row.bankType == 1">ملت</span>
                      <span v-else-if="row.bankType == 2">ملی</span>
                      <span v-else-if="row.bankType == 3">مسکن</span>
                      <span v-else-if="row.bankType == 4">سپه</span>
                      <span v-else-if="row.bankType == 5">پاسارگاد</span>
                      <span v-else-if="row.bankType == 6">پارسیان</span>
                      <span v-else-if="row.bankType == 7">ایران خودرو</span>
                      <span v-else-if="row.bankType == 8">اسنپ‌پی</span>
                      <span v-else>متفرقه</span>
                    </span>
                    <span v-else>--- </span>
                  </td>
                  <td style="width: 20%">
                    <span v-if="row.description == null">-</span>
                    {{ row.description }}
                  </td>
                  <td style="width: 20%; direction: ltr">
                    {{ row.createOn.split(" ")[0] }}<br />{{
                      row.createOn.split(" ")[1]
                    }}
                  </td>
                </template>
              </data-grid>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
#reset-btn {
  margin-left: 1.5rem;
  background: #3ec9d6 !important;
}
</style>

<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import vSelect from "@/components/CustomVSelect.vue";

export default {
  name: "FinancialManagement_BankPortalPayments_RejectPayment",
  components: {
    DataGrid,
    "v-select": vSelect,
  },
  data() {
    return {
      showFilters: false,
      gridDataSource: {
        type: "app",
        service: "/Sales/api/BankPaymentsQuery",
      },
      gridSearchData: {
        isConfrimed: "false",
      },
      bankPaymentStates: [
        { id: 1, title: "ایجاد" },
        { id: 2, title: "توکن از بانک دریافت گردید" },
        { id: 3, title: "تایید مرحله اول از بانک" },
        { id: 4, title: "تراکنش موفق" },
        { id: 5, title: "تراکنش ناموفق" },
      ],
      saleInterfaces: [
        { id: 1, title: "نمایندگان" },
        { id: 2, title: "مصرف کننده نهایی" },
      ],
      bankTypes: [{ id: 1, title: "ملت" }],
    };
  },
  methods: {
    submitFilter() {
      this.$refs.grid.renderGrid(1, true);
    },
    resetForm() {
      this.gridSearchData = {
        State: "",
        SaleInterface: "",
        BankType: "",
        isConfrimed: "false",
      };
      setTimeout(() => {
        this.$refs.grid.renderGrid(1, true);
      }, 0);
    },
  },
};
</script>
